import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, status, isAuthenticated } = useAuth();
  const location = useLocation();

  // Wait for booting to complete
  if (loading || status === 'booting') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C05621]"></div>
          <p className="text-[#5C554B] text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (status === 'unauthenticated' || !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role permissions
  if (allowedRoles.length > 0 && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading, status } = useAuth();

  // Wait for booting to complete
  if (loading || status === 'booting') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C05621]"></div>
          <p className="text-[#5C554B] text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  // If authenticated, redirect to dashboard
  if (status === 'authenticated' && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
